<template>
  <div :id="randomID">
    <vue-excel-editor
      v-model="cartItemList"
      style="width: 100%"
      :free-select="true"
      :enter-to-south="true"
      :no-header-edit="true"
      :processing="loading"
      :multi-update="true"
      @update="updateCartItem"
    >
      <vue-excel-column
        field="cartItemID"
        :key-field="true"
        :invisible="true"
      />
      <vue-excel-column
        v-if="dealer"
        type="select"
        field="person"
        :label="$t('person2')"
        :options="personList"
        :validate="validPerson"
        @update="updateCartItem"
      />
      <vue-excel-column
        v-if="dealer"
        field="dimensionObjectfirstname"
        :label="$t('firstName')"
      />
      <vue-excel-column
        v-if="dealer"
        field="dimensionObjectlastname"
        :label="$t('lastName2')"
      />
      <vue-excel-column
        v-if="affiliate === 'HCI'"
        field="pN"
        width="40px"
        :label="$t('pn')"
      />
      <vue-excel-column
        field="itemDescription"
        :label="$t('item')"
        width="130px"
        :readonly="true"
      />
      <vue-excel-column
        field="variantDescription"
        :label="$t('variant')"
        width="55px"
        :readonly="true"
      />
      <vue-excel-column
        field="qty"
        :label="$t('qty')"
        width="40px"
        text-align="right"
        :readonly="true"
      />
      <vue-excel-column field="comment" :label="$t('comments')" />
      <vue-excel-column
        field="reference"
        :length-limit="15"
        :label="$t('reference')"
      />
      <vue-excel-column
        field="extraLabel"
        :length-limit="30"
        :label="$t('extraLabel')"
      />

      <vue-excel-column
        width="300px"
        field="optionDescription"
        :label="$t('options')"
        :readonly="true"
      />
      <vue-excel-column
        v-if="cart.totalNettExcVAT"
        field="unitPrice"
        :label="$t('price')"
        text-align="right"
        type="number"
        :readonly="true"
      />
      <vue-excel-column
        v-if="cart.totalNettExcVAT"
        field="lineTotal"
        :label="$t('total')"
        text-align="right"
        cell-style="text-align: right;"
        type="number"
        :readonly="true"
      />
      <vue-excel-column
        field="files"
        :label="$t('upload')"
        type="upload"
        width="60px"
        :readonly="true"
      />
      <vue-excel-column
        field="edit"
        label=""
        type="edit"
        width="42px"
        :readonly="true"
      />
      <vue-excel-column
        field="remove"
        label=""
        type="remove"
        width="42px"
        :readonly="true"
      />
    </vue-excel-editor>
    <i v-if="mutatingCartItems.length > 0" class="fas fa-spinner fa-spin"></i>
  </div>
</template>

<!--suppress AllyPlainJsInspection -->
<script>
import { patchCartItem } from "../../services/cart"
import sanitizeCartItems from "@/functions/sanitizeCartItems"

import VueExcelEditor from "../excel-editor/VueExcelEditor.vue"
import VueExcelColumn from "../excel-editor/VueExcelColumn.vue"

export default {
  components: { VueExcelEditor, VueExcelColumn },
  props: {
    cartItems: {
      type: Array,
      required: true,
    },
    persons: {
      type: Array,
      required: false,
      default: function () {
        return []
      },
    },
    dealer: {
      type: Boolean,
      required: false,
      default: false,
    },
    affiliate: {
      type: [Boolean, String],
      required: false,
      default: function () {
        return "VIN"
      },
    },
    customerid: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function () {
    return {
      mutatingCartItems: [],
      randomID: `grid-${Math.random().toString(36).substring(2, 15)}`,
      cartItemList: [],
      selectedCartItemID: "",
      loading: false,
    }
  },
  computed: {
    personList() {
      return this.persons.map((person) => person.value)
    },
    cart() {
      return this.$store.state.cart
    },
  },
  watch: {
    cartItems: function () {
      this.cartItemList = sanitizeCartItems(this.cartItems)
    },
  },
  created() {
    this.cartItemList = sanitizeCartItems(this.cartItems)
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    validPerson(content, oldContent, record, field) {
      if (!this.personList.includes(content.trim()))
        return this.$t("personDoesNotExist")
      return "" // return empty string if there is no error
    },
    updateCartItem: async function (cartItems) {
      //Get actual option value instead of description
      this.loading = true

      const rows = await this.checkIfMultiRowEdit(
        cartItems[0].keys[0],
        cartItems[0].newVal
      )

      if (rows) {
        await this.applyMultiRowData({
          rows,
          cartItemID: cartItems[0].keys[0],
          name: cartItems[0].name,
        })
        await this.$store.dispatch("updateCart")
        this.loading = false
        return
      }

      for (const cartItem of cartItems) {
        // Valid conditions have not been met
        if (cartItem.err) return

        this.mutatingCartItems.push(cartItem.keys[0])
        let formattedCartItem = {}

        formattedCartItem.cartItemID = cartItem.keys[0]
        formattedCartItem[cartItem.name] = cartItem.newVal.trim()

        await patchCartItem({ cartItem: formattedCartItem })

        this.mutatingCartItems.splice(
          this.mutatingCartItems.indexOf(cartItem.keys[0], 1)
        )
        await this.$store.dispatch("updateCart")
      }

      this.loading = false
    },
    checkIfMultiRowEdit(cartItem, newVal) {
      const multiLine = newVal.trim().split("\r\n")

      return multiLine
    },
    async applyMultiRowData({ rows, cartItemID, name }) {
      const index = this.cartItemList.findIndex(
        (cartItem) => cartItem.cartItemID === cartItemID
      )
      let currentIndex = index
      let rowIndex = 0

      while (currentIndex < index + rows.length) {
        this.cartItemList[currentIndex][name] = rows[rowIndex]

        const cartItemChanges = {}
        cartItemChanges.cartItemID = this.cartItemList[currentIndex].cartItemID
        cartItemChanges[name] = rows[rowIndex]

        await patchCartItem({
          cartItem: cartItemChanges,
        })
        rowIndex++
        currentIndex++
      }
    },
  },
}
</script>
<style>
.vue-excel-editor table {
  margin-bottom: 0px;
}
.vue-excel-editor tr:nth-of-type(odd) {
  background-color: #e9ecef !important;
}
.systable .first-col {
  background: transparent !important;
}
table#systable {
  width: 100% !important;
}
</style>
